<div class="not-found-container">
  <i class="fa-light fa-cloud-exclamation"></i>
  <p>{{ app.text.app.noDataAvailable }}</p>
  <button class="btn btn-default-orange" (click)="app.routing.navigateBack()">
    Go back
  </button>
</div>
